module.exports = __webpack_public_path__ + "ro.svg?c25fdab278341db26bb7da66543965ee";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/ro.svg
// module id = 1115
// module chunks = 27